<svg
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 12 14">
    <path d="M7 10.75v-1.5q0-0.109-0.070-0.18t-0.18-0.070h-1.5q-0.109 0-0.18 0.070t-0.070 0.18v1.5q0 0.109 0.070 0.18t0.18 0.070h1.5q0.109 0 0.18-0.070t0.070-0.18zM9 5.5q0-0.688-0.434-1.273t-1.082-0.906-1.328-0.32q-1.898 0-2.898 1.664-0.117 0.187 0.062 0.328l1.031 0.781q0.055 0.047 0.148 0.047 0.125 0 0.195-0.094 0.414-0.531 0.672-0.719 0.266-0.187 0.672-0.187 0.375 0 0.668 0.203t0.293 0.461q0 0.297-0.156 0.477t-0.531 0.352q-0.492 0.219-0.902 0.676t-0.41 0.98v0.281q0 0.109 0.070 0.18t0.18 0.070h1.5q0.109 0 0.18-0.070t0.070-0.18q0-0.148 0.168-0.387t0.426-0.387q0.25-0.141 0.383-0.223t0.359-0.273 0.348-0.375 0.219-0.473 0.098-0.633zM12 7q0 1.633-0.805 3.012t-2.184 2.184-3.012 0.805-3.012-0.805-2.184-2.184-0.805-3.012 0.805-3.012 2.184-2.184 3.012-0.805 3.012 0.805 2.184 2.184 0.805 3.012z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-question-circle.html